import { loyaltyConsentCookieValue } from '../../infrastructure/Configuration'
import AuthService from '../../services/AuthService'
import Filter from '../domain/Filter'
import Currencies from '@/domain/Currencies'
import ExternalStorage from '@/services/ExternalStorage'

export default {
  hotel: null,
  nearbyHotels: [],
  loyaltyConsentAccepted: loyaltyConsentCookieValue,
  bookingStayInProgress: null,
  customer: AuthService.currentCustomer(),
  staysHasBeenLoading: false,
  exchangeRates: Currencies.empty(),
  currenciesList: [],
  tripAdvisorHotelInfo: null,
  labelsLoaded: false,
  filter: Filter.empty(),
  filteredHotel: null,
  taxIncludedRegion: ExternalStorage.cookies.taxIncludedRegion(),
  taxExcludedRegion: ExternalStorage.cookies.taxExcludedRegion(),
  isUk: ExternalStorage.cookies.isUk(),
  error: null,
  membersBenefits: null,
  dataQubit: {},
  coBrandImg: null,
  coBrandHotels: {}
}
